import { render, staticRenderFns } from "./PartSupplierDetailCard.vue?vue&type=template&id=4da46ba0"
import script from "./PartSupplierDetailCard.vue?vue&type=script&lang=js"
export * from "./PartSupplierDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports